import { UserProfile } from '@cpd-app/core-module/models';

export const userProfileFeatureKey = 'userProfile';

export interface UserProfileState {
  userProfile: UserProfile;
  userShareProfile: UserProfile;
  isUserProfileSaved: boolean;
}

export const initialUserProfileState: UserProfileState = {
  userProfile: null,
  userShareProfile: null,
  isUserProfileSaved: false
};
